import React from "react";
import Message from "ui/FlashMessages/Message";
import { FlashMessageStateInterface, FlashMessage } from "context/FlashMessages/Context";

type Props = {
    flash: FlashMessageStateInterface;
};

const animationDuration = 750;

const FlashMessages: React.FC<Props> = ({ flash }) => {
    const onFlashFadeOut = (flashMessage: FlashMessage) => {
        flash.actions.removeFlashMessage(flashMessage.id);
    };

    return (
        <div className="flash-message-container">
            {flash.messages.map((message) => (
                <Message
                    key={message.id}
                    onFadeOut={() => onFlashFadeOut(message)}
                    duration={message.duration}
                    animationDuration={animationDuration}
                    content={message.text}
                    type={message.type}
                />
            ))}
        </div>
    );
};

export default FlashMessages;
